enum Permission {
  ReadVisits = 'read:visits',
  ReadWorkAreas = 'read:work-areas',
  ReadEquipments = 'read:equipments',
  WriteEquipments = 'write:equipments',
  EquipmentsAssignment = 'equipments-assignment',
  ReadJobs = 'read:jobs',
  StartFinishJobs = 'start-finish-jobs',
  ReadWorkInstructions = 'read:work-instructions',
  ConfirmWorkInstructions = 'confirm-work-instructions',
  ReadReeferTemperatures = 'read:reefer-temperatures',
  ReadStoppageReasons = 'read:stoppage-reasons',
  WriteStoppageReasons = 'write:stoppage-reasons',
  ReadShift = 'read:shift',
  WriteShift = 'write:shift',
  ReadGangs = 'read:gangs',
  WriteGangs = 'write:gangs',
  ReadMasterData = 'read:master-data',
  LogOutOtherOperators = 'log-out-other-operators',

  // Planning Permissions
  ReadVessels = 'read:vessels',
  WriteVessels = 'write:vessels',
  WriteOrders = 'write:orders',
  ReadOrders = 'read:orders',
  ReadRailVisits = 'read:rail-visits',
  WriteRailVisits = 'write:rail-visits',
  ReadRailCars = 'read:rail-cars',
  WriteRailCars = 'write:rail-cars',
  ReadWriteExternalDrivers = 'read:external-drivers',
  WriteDangerousGoodsSettings = 'write:dangerous-goods-settings',
  // End Planning Permissions

  // Admin Permissions
  Admin = 'admin',
  ReadUsers = 'read:users',
  WriteUsers = 'write:users',
  ReadAdminTenant = 'read:admin-tenant',
  ReadTenants = 'read:tenants',
  WriteTenants = 'write:tenants',
  AssignRoles = 'write:assign-roles',
  ReadDamageCatalogue = 'read:damage-catalogue',
  WriteDamageCatalogue = 'write:damage-catalogue',
  // End Admin Permissions

  // Storage Permissions
  ReadYardBlocks = 'read:yard-blocks',
  WriteYardBlocks = 'write:yard-blocks',

  ReadPiers = 'read:piers',
  WritePiers = 'write:piers',

  ReadBerths = 'read:berths',
  WriteBerths = 'write:berths',

  ReadRules = 'read:rules',
  WriteRules = 'write:rules',

  WriteSuperuser = 'write:superuser',
  ReadSuperuser = 'read:superuser',

  ReadRailTracks = 'read:rail-tracks',
  WriteRailTracks = 'write:rail-tracks',

  ReadWeightClasses = 'read:weight-classes',
  WriteWeightClasses = 'write:weight-classes',

  ReadDangerousGoodsSettings = 'read:dangerous-goods-settings',

  ReadYardPlanning = 'read:yard-planning',
  ReadLocationCodes = 'read:location-codes',

  ReadStowageInstructions = 'read:stowage-instructions',
  WriteStowageInstructions = 'write:stowage-instructions',

  ResetData = 'reset-data',

  // Billing Service Permissions
  ReadBillableReport = 'read:billable_report',
  ReadCompanies = 'read:companies',
  WriteCompanies = 'write:companies',
  ReadCommodities = 'read:commodities',
  WriteCommodities = 'write:commodities',
  // End Billing Service Permissions
}

export default Permission
